// extracted by mini-css-extract-plugin
module.exports = {"root":"FullPage404_root__2wSfJ","logo":"FullPage404_logo__2ha7A"};